// Local translations
export const T = {
  en_GB: {
    filterTenants: "Filter tenants",
    allTenants: "All Tenants",
    partnersOnly: "Partners Only",
    ownedBy: "Owned by:",
    addTenant: "Add Tenant",
    searchPlaceholder: "Search tenants...",
    noSearchResults: "No tenants match your search.",
    noMatchingTenants: "No tenants match this filter.",
  },
  nb_NO: {
    filterTenants: "Filtrer organisasjoner",
    allTenants: "Alle organisasjoner",
    partnersOnly: "Kun partnere",
    ownedBy: "Eid av:",
    addTenant: "Legg til organisasjon",
    searchPlaceholder: "Søk etter organisasjoner...",
    noSearchResults: "Ingen organisasjoner samsvarer med søket ditt.",
    noMatchingTenants: "Ingen organisasjoner samsvarer med dette filteret.",
  },
} as const;
